export default __webpack_public_path__ + "static/media/nevvon.282305b7.png";